import { render } from "./collapse.vue?vue&type=template&id=39e8ab5e&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=39e8ab5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e8ab5e"]])

export default __exports__